import { Box, Heading, Image, Text } from "@chakra-ui/react";
import React from "react";
import privacy from "../../assets/privacy.png";

const Refund = () => {
  return (
    <Box w={"100%"} textAlign={"left"}>
      <Image src={privacy} w={"100%"} />
      <Box px={14} py={10}>
        <Heading color={"#3C375F"} mt={5} className="oswald-font">
          Refund Process
        </Heading>
        <Text
          color={"#FF1C6B"}
          fontWeight={"bold"}
          fontSize={20}
          mt={4}
          className="oswald-font"
        >
          Refund policy - wishfy
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          We want your shopping experience with Wishfy to be hassle-free and
          enjoyable. Here’s everything you need to know about our refund
          process:
        </Text>
        <Text
          color={"#FF1C6B"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Cancellations:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          If you need to cancel your order before it’s shipped, please contact
          us promptly. We’ll cancel your order and initiate a refund to your
          original payment method.
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          If your order has already been shipped and you wish to cancel, we
          recommend refusing the delivery when it arrives. Once the item is
          returned to our warehouse, we’ll process your refund.
        </Text>
        <Text
          color={"#FF1C6B"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Product or delivery concerns:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          If you receive a product with any of the following issues – product
          damage, defects, incorrect delivery, incomplete delivery, or
          functional problems – please reach out to us within 7 days of
          receiving your order. We’ll promptly issue a replacement or refund to
          your original payment method.
        </Text>
        <Text
          color={"#FF1C6B"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Changed your mind or not satisfied:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          If, for any other reason, you’re not satisfied with your purchase, you
          have a generous 7-day window from the date of delivery to return the
          product to us.
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          In such cases, we issue refunds in the form of store credit, which can
          be used for future purchases on Wishfy with no expiration date. Once
          we receive the returned item in good condition, the gift card will be
          issued.
        </Text>
        <Text
          color={"#FF1C6B"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Please note that shipping fees are deducted based on the following
          slabs:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          Order amount up to Rs. 1000: Rs. 100
          <br /> Order amount Rs. 1001-2000: Rs. 150
          <br /> Order amount higher than Rs. 2000: Rs. 250
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          The entire process, including pick-up, inspection, and gift card
          issuance, takes about 8-10 business days. Your patience is
          appreciated.
        </Text>

        <Text
          color={"#FF1C6B"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Exclusions from return/exchange:
        </Text>
        <Text
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
        >
          Certain items are not eligible for return or exchange:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          Consumables (e.g., essential oils, perfumes) once opened and consumed.
          <br />
          Products with sizes that match our website descriptions.
          <br />
          Products with slight color variations from website images due to
          device settings and lighting.
          <br />
          Fragile items such as ceramics and glassware unless they reached you
          in damaged condition.
        </Text>
        <Text
          color={"#FF1C6B"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          How to initiate a return:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          Online: Login with your email, view your orders, select the order you
          want to return, choose a return reason, and add a note for the store.
          Submit your request.
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          WhatsApp: Message us at +918287255732 or click here to share your
          concern, and we’ll assist you further.
        </Text>
        <Text
          color={"#FF1C6B"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Packing your return:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          Please use the original product packaging whenever possible for safe
          transit. Handling returned items with care is crucial, as we cannot
          process a refund for items damaged during return transit.
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className={"lato-font"}
        >
          If you have any questions or need assistance with our return policy,
          please don’t hesitate to reach out to our customer support team on
          WhatsApp. We’re here to assist you!
        </Text>
      </Box>
    </Box>
  );
};

export default Refund;
